import { Theme, css } from '@emotion/react';

export const pageTitle = ({ colors, spacing }: Theme) => css`
  border-bottom: 1px solid ${colors.borderDefault};
  padding-bottom: ${spacing(4)}px;
`;

export const additionalInfoTable = css`
  border: 1px solid black;
  border-collapse: separate;
  width: 100%;
  margin: auto;
`;

export const additionalInfoTableRow = css`
  border: 1px solid black;
  border-collapse: separate;
  border-bottom: solid;
`;

export const additionalInfoTableCell = css`
  border: 1px solid black;
`;
